module.exports = __webpack_public_path__ + "static/media/iconmap.c06a7db4.png";